  $(".hero-scrolling-banner-bg").slick({
   slidesToShow: 1,
   infinite:true,
   slidesToScroll: 1,
   autoplay: true,
   autoplaySpeed: 6000,
   dots: true,
   arrows: false
  });

  $(document).ready(function(){
    
    // If the page content dom ele and url contain product handel.
    if( $(".variant-box").length > 1 && window.location.pathname.indexOf('/products/') == 0){

        // on box selection click
        $(".variant-box").click(function(){

            // clicked var_id
            var sel_vid = $(this).attr('variant-id');
            
            // box selection logic
            $(".variant-box").removeClass("is_selected_cu");
            $(this).addClass('is_selected_cu');

            var $d, $product_info_compare;
            var push_price, v_price, m_price, price_normal, price_slacked;
            $product_info_compare = $(".product-info__price").find("compare-at-price");
             
            // set updated url parameter
            const url_in = new URL(window.location.href);
            url_in.searchParams.set('respawn', '1'); 
            url_in.searchParams.set('variant', sel_vid);
            window.history.pushState(null, '', url_in.toString());
             
             // set hidden parameter for variant change on page load
            $d = $(".product-info__buy-buttons").find("[name='id']");
            $d.attr("value", sel_vid);
 
             // emulate click for hidden parameter
            push_price = $(".variant-box[variant-id='"+ sel_vid +"']").find('label').attr('for');
            $('#' + push_price).click();
             
             
            // remove hidden tags and replace class
            $product_info_compare.removeAttr("hidden");
             
 
            // Place the classes only when duplicate does not exist( for main price )
            if( $product_info_compare.find('span.money').length < 1 ){
                $product_info_compare.find("span.sr-only").removeClass('sr-only').addClass("money");
            }
            
            // get variant price
            v_price = $(".variant-box[variant-id='"+ sel_vid +"']").find('.vpricebox').find(".money");
            
            // Replace the main price on page load
            // When price slack is not present
            if( v_price.length < 2 ){
                price_normal = v_price.get(0).innerHTML;
                price_slacked = '';
                 
            }else{
                price_normal = v_price.get(0).innerHTML;
                price_slacked = v_price.get(1).innerHTML;
                
            }

            // place them.
            m_price = $(".product-info__price").find(".money");
            m_price.get(1).innerHTML = price_normal;
            m_price.get(0).innerHTML = price_slacked;
        });
        
        // check url parameter for first load
        var respawn = GetParameterValues("respawn");

        // To check if a URL is of particular product
        if (window.location.href.includes("moringa-a2-ghee")) {
            // get second product variant or any, starts from 0.
            var default_var = $(".variant-box:eq(0)").attr("variant-id");
        } else {
            // get second product variant or any, starts from 0.
            var default_var = $(".variant-box:eq(1)").attr("variant-id");
        }
        
        // on page load adjust selection based on url parameter
        var v_select = GetParameterValues("variant");

        // on page load set
        $(".variant-box").each(function(){
            if($(this).attr('variant-id') == v_select){
             
                $(".variant-box").not(this).removeClass("is_selected_cu");
                $(this).addClass('is_selected_cu');
                return false;
 
            }
        });


        if( typeof respawn == 'undefined' ){

            var $d, $product_info_compare;
            var push_price, v_price, m_price, price_normal, price_slacked;
            $product_info_compare = $(".product-info__price").find("compare-at-price");
            

            // box selection logic
            $(".variant-box").removeClass("is_selected_cu");
            $(".variant-box[variant-id='"+ default_var +"']").addClass('is_selected_cu');
            
            // set updated url parameter
            const url = new URL(window.location.href);
            url.searchParams.set('respawn', '1'); 
            url.searchParams.set('variant', default_var);
            window.history.pushState(null, '', url.toString());
            
            // set hidden parameter for variant change on page load
            $d = $(".product-info__buy-buttons").find("[name='id']");
            $d.attr("value", default_var);

            // emulate click for hidden parameter
            push_price = $(".variant-box[variant-id='"+ default_var +"']").find('label').attr('for');
            $('#' + push_price).click();
            
            // remove hidden tags and replace class
            $product_info_compare.removeAttr("hidden");
            
            // Place the classes only when duplicate does not exist( for main price )
            if( $product_info_compare.find('span.money').length < 1 ){
                $product_info_compare.find("span.sr-only").removeClass('sr-only').addClass("money");
            }
            
            // get variant price
            v_price = $(".variant-box[variant-id='"+ default_var +"']").find('.vpricebox').find(".money");
           
            
            // Replace the main price on page load
            // When price slack is not present
            if( v_price.length < 2 ){
                price_normal = v_price.get(0).innerHTML;
                price_slacked = '';
            }else{
                price_normal = v_price.get(0).innerHTML;
                price_slacked = v_price.get(1).innerHTML;
                }
                
            // place them
            m_price = $(".product-info__price").find(".money");
            m_price.get(1).innerHTML = price_normal;
            m_price.get(0).innerHTML = price_slacked;
            
        }
            
        function GetParameterValues(param) {
            var url = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
            for (var i = 0; i < url.length; i++) {
                var urlparam = url[i].split('=');
                if (urlparam[0] == param) {
                    return urlparam[1];
                }
            }
        }
    }



    //console.log(window.location.pathname.indexOf('/cart/'));
    
    // inititate main quantity changer
    attachCartEvents();

    // attach event listner for the cart change
    document.addEventListener("cart:change", function(){
       
        //console.log('kevin');
        
        setTimeout(function(){
            attachCartEvents();
        }, 2000);
    }); 

    // update cart items
    function updateCartItem( variant_id, quantity, operation){
        
        //co
        var data = { updates: {} };
        var item_count;
        //var data = [{ quantity: quantity, id: variant_id }];
        data.updates[variant_id] = quantity;
        
        $(".loading_wait").show();
        $(".loading_overlay").show();

        jQuery.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: data,
            dataType: 'json',
            success: function(result) { 
               
                $.when( 
                    jQuery.getJSON('/cart.js', function(cart) {
                        
                        item_count = cart.item_count;
                        let cartData = cart.items;
                        document.dispatchEvent(new CustomEvent('cart:build' ,{
                                bubbles: true
                            }
                        )); 
                        document.dispatchEvent(new CustomEvent('cart:refresh', {
                            bubbles: true,
                            detail: cartData
                        })); 
                    })
                ).then(function(){
                    
                    setTimeout(function(){
                        
                        // don't re-attach
                        if( window.location.pathname.indexOf('/cart/') == -1)
                            attachCartEvents();

                        $(".header__cart-count").find(".count-bubble").html(item_count);
                        $(".loading_wait").hide();
                        $(".loading_overlay").hide();
                        
                        // console.log('re-attached');
                    }, 2000);

                });
            }
        });
    }

    // main function for event attaching event listners
    function attachCartEvents(){
        $(".i_minus_cart").click(function(){
            //console.log("MINUS");
            
            var minus;
            
            let $inputBox = $(this).parents('.line_changer').find('input.quantity-input');

            minus = parseInt( $inputBox.attr('value') ) - 1;
            
            $inputBox.attr('value', minus);
            
            //console.log($inputBox.attr('value'));
            //console.log(minus);
            //$(this).parents('.line-item').find('.line_item_hdn').find('input.quantity-input').attr('value', minus);
    
            var variant_id = $(this).parents('.line_changer').attr("line_var_id");
          
            updateCartItem(variant_id, minus, 'minus'); 
    
        });
        
        $(".i_plus_cart").click(function(){
            //console.log('PLUS')
            
            var plus, max, currrent_qty;
            let $inputBox = $(this).parents('.line_changer').find('input.quantity-input');
            
            currrent_qty = parseInt( $inputBox.attr('value') );
            plus = currrent_qty + 1;
                
            $inputBox.attr('value', plus);

            //console.log(currrent_qty);
            //console.log(plus);
            //$(this).parents('.line-item').find('.line_item_hdn').find('input.quantity-input').attr('value', plus);

            var variant_id = $(this).parents('.line_changer').attr("line_var_id");
            updateCartItem(variant_id, plus, 'plus'); 
    
        });
    }
});


document.addEventListener("DOMContentLoaded", function () {
  // Select all FAQ sections
  const faqSections = document.querySelectorAll(".faq-section");

  faqSections.forEach(section => {
    const faqItems = section.querySelectorAll(".faq-item");

    // First FAQ open by default in this section
    if (faqItems.length > 0) {
      const first = faqItems[0];
      const firstBtn = first.querySelector(".faq-question");
      const firstAns = first.querySelector(".faq-answer");

      first.classList.add("open");
      firstBtn.setAttribute("aria-expanded", "true");
      firstAns.style.display = "block";
    }

    // Add click event for each question in this section only
    const questionButtons = section.querySelectorAll(".faq-question");

    questionButtons.forEach(button => {
      button.addEventListener("click", () => {
        const parent = button.closest(".faq-item");
        const expanded = button.getAttribute("aria-expanded") === "true";

        // Close all FAQs in this section
        faqItems.forEach(item => {
          item.classList.remove("open");
          const btn = item.querySelector(".faq-question");
          const ans = item.querySelector(".faq-answer");
          if (btn) btn.setAttribute("aria-expanded", "false");
          if (ans) ans.style.display = "none";
        });

        // If clicked one was closed → open it
        if (!expanded) {
          parent.classList.add("open");
          button.setAttribute("aria-expanded", "true");
          const answer = parent.querySelector(".faq-answer");
          if (answer) answer.style.display = "block";
        }
      });
    });
  });
});



// faq page js
document.addEventListener("DOMContentLoaded", function () {
  const faqWrapper = document.querySelector(".faq_tab_sec_wrapper");

  if (faqWrapper) {
    window.addEventListener("scroll", function () {
      if (window.scrollY > 400) {
        faqWrapper.classList.add("fixed");
      } else {
        faqWrapper.classList.remove("fixed");
      }
    });
  }
});


document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".faq-tab-btn");

  buttons.forEach((btn) => {
    btn.addEventListener("click", function () {
      // Remove active class from all buttons
      buttons.forEach((b) => b.classList.remove("active"));

      // Add active class to the clicked one
      this.classList.add("active");

      // Scroll to target section
      const target = document.querySelector(this.getAttribute("data-target"));
      if (target) {
        target.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function() {
  const toggles = document.querySelectorAll(".footer-mobile .accordion-toggle");

  // Open the first accordion by default on mobile
  if (window.innerWidth <= 767 && toggles.length > 0) {
    const firstToggle = toggles[0];
    const firstContent = firstToggle.nextElementSibling;
    firstToggle.classList.add("active");
    firstContent.style.maxHeight = firstContent.scrollHeight + "px";
  }

  toggles.forEach(toggle => {
    toggle.addEventListener("click", function() {
      if (window.innerWidth <= 767) {
        const content = this.nextElementSibling;
        const isActive = this.classList.contains("active");

        // ✅ Close all other accordions
        toggles.forEach(otherToggle => {
          if (otherToggle !== this) {
            otherToggle.classList.remove("active");
            otherToggle.nextElementSibling.style.maxHeight = null;
          }
        });

        // ✅ Toggle current one
        if (!isActive) {
          this.classList.add("active");
          content.style.maxHeight = content.scrollHeight + "px";
        } else {
          this.classList.remove("active");
          content.style.maxHeight = null;
        }
      }
    });
  });
});


// mega menu js
document.addEventListener("DOMContentLoaded", function () {
  // Tab switching
  document.querySelectorAll(".mega-menu-tabs .tab-btnn").forEach((btnn) => {
    btnn.addEventListener("click", function () {
      let ctabId = this.dataset.tab;

      document
        .querySelectorAll(".mega-menu-tabs .tab-btnn")
        .forEach((bb) => bb.classList.remove("activee"));
      this.classList.add("activee");

      document
        .querySelectorAll(".mega-menu-collection .tab-panee")
        .forEach((panee) => {
          panee.classList.remove("activee");
          if (panee.id === ctabId) {
            panee.classList.add("activee");

            // ✅ Refresh Swiper after tab becomes visible
            let sliderr = panee.querySelector(".collection-products.swiper");
            if (sliderr && sliderr.swiper) {
              setTimeout(() => {
                sliderr.swiper.update();
              }, 200); // small delay ensures correct width calc
            }
          }
        });
    });
  });

// function initProductSliderc() {
//   const breakpoint = 768; // only swiper above this width

//   document.querySelectorAll(".collection-products.swiper").forEach((sliderr) => {
//     if (window.innerWidth >= breakpoint) {
//       if (!sliderr.classList.contains("swiper-initialized")) {
//         new Swiper(sliderr, {
//           loop: false, // no white space after last product
//           slidesPerView: 4, // show 4 products
//           slidesPerGroup: 1, // swipe one by one so last 2 are reachable
//           spaceBetween: 20,
//           navigation: {
//             nextEl: ".swiper-button-next",
//             prevEl: ".swiper-button-prev",
//           },
//           breakpoints: {
//             1920: {
//               slidesPerView: 4,
//               spaceBetween: 30,
//             },
//             1028: {
//               slidesPerView: 2,
//               spaceBetween: 20,
//             },
//             480: {
//               slidesPerView: 1,
//               spaceBetween: 10,
//             },
//           },
//         });
//       }
//     } else {
//       // Destroy swiper on mobile < 768px
//       if (sliderr.swiper) {
//         sliderr.swiper.destroy(true, true);
//       }
//     }
//   });
// }

// Run on page load
//initProductSliderc();

// Run on window resize
// window.addEventListener("resize", initProductSliderc);


});

document.addEventListener("DOMContentLoaded", function () {
  const $popup = $("#video-popup");
  const $slider = $(".video-slider");
  let slickInitialized = false;

  // Pause + reset all videos
  function pauseAllVideos() {
    $slider.find("video").each(function () {
      this.pause();
      this.currentTime = 0;
    });
  }

  // Initialize Slick once
  function initSlick() {
    if (slickInitialized) return;

    $slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      dots: false,
      centerMode: true,
      centerPadding: "100px",
      prevArrow: `
        <button type="button" class="slick-prev custom-prev">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M3.00001 8.99988H15" stroke="#928777" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M6.74992 12.75C6.74992 12.75 3 9.9882 3 9C3 8.0118 6.75 5.25 6.75 5.25" stroke="#928777" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      `,
      nextArrow: `
        <button type="button" class="slick-next custom-next">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M15 8.99988H3" stroke="#928777" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M11.2501 12.75C11.2501 12.75 15 9.9882 15 9C15 8.0118 11.25 5.25 11.25 5.25" stroke="#928777" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      `,
      responsive: [
        {
          breakpoint: 576,
          settings: { centerPadding: "40px" }
        }
      ]
    });

    // When slide changes, pause all and play current
    $slider.on("afterChange", function (event, slick, currentSlide) {
      pauseAllVideos();
      const currentVideo = $(slick.$slides[currentSlide]).find("video").get(0);
      if (currentVideo) {
        currentVideo.muted = true;
        currentVideo.play().catch(err => console.warn("Autoplay failed:", err));
      }
    });

    slickInitialized = true;
  }

  // ✅ Open popup + autoplay video
  document.querySelectorAll(".open-video-popup").forEach((trigger) => {
    trigger.addEventListener("click", function (e) {
      e.preventDefault();

      const index = $(this).data("index") || 1;
      initSlick();

      pauseAllVideos();
      $popup.removeClass("hidden");

      // Wait a tick so slick positions correctly
      setTimeout(() => {
        $slider.slick("slickGoTo", index - 1, true);

        // 🔥 Force autoplay current video immediately (first time too)
        setTimeout(() => {
          const currentVideo = $slider.find(".slick-current video").get(0);
          if (currentVideo) {
            currentVideo.muted = true; // important for autoplay
            currentVideo.currentTime = 0;
            currentVideo.play().catch(err => console.warn("Autoplay blocked:", err));
          }
        }, 150);
      }, 100);
    });
  });

  // ✅ Close popup
  $(".close-popup, #video-popup").on("click", function (e) {
    if (e.target !== this && !$(e.target).hasClass("close-popup")) return;
    pauseAllVideos();
    $popup.addClass("hidden");
  });
});






// div wrapper product page 
  // Select only the two specific block types
  var $blocksToWrap = $(".product-info>[data-block-type='benefits-tab']:nth-child(1), .product-info>[data-block-type='@app']:nth-child(2)");

  // Wrap them together only if both exist
  if ($blocksToWrap.length === 2) {
    $blocksToWrap.wrapAll('<div class="wrapped-benefits-app"></div>');
  } 



  document.addEventListener("DOMContentLoaded", function() {
  const slider = document.querySelector(".swiper-wrapper");
  let isDown = false;
  let startX;
  let scrollLeft;

  slider.addEventListener("mousedown", (e) => {
    isDown = true;
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });

  slider.addEventListener("mouseleave", () => {
    isDown = false;
  });

  slider.addEventListener("mouseup", () => {
    isDown = false;
  });

  slider.addEventListener("mousemove", (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 1.5; // scroll speed
    slider.scrollLeft = scrollLeft - walk;
  });
});



document.addEventListener("DOMContentLoaded", function() {
  if(document.querySelector(".collection_flex_menu")){
    const slider = document.querySelector(".collection_flex_menu");
    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener("mousedown", (e) => {
      isDown = true;
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener("mouseleave", () => {
      isDown = false;
    });

    slider.addEventListener("mouseup", () => {
      isDown = false;
    });

    slider.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 1.5; // scroll speed
      slider.scrollLeft = scrollLeft - walk;
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const stickyATC = document.querySelector(".product-quick-add");
  if (!stickyATC) return;

  const scrollOffset = 300; // show after 300px scroll (adjust as needed)

  function toggleStickyATC() {
    if (window.scrollY > scrollOffset) {
      stickyATC.classList.add("is-visible");
    } else {
      stickyATC.classList.remove("is-visible");
    }
  }

  window.addEventListener("scroll", toggleStickyATC);
});


$(document).ready(function () {
  $("li.main_menu_cu > a").on("click", function (e) {
    e.preventDefault(); // stop link navigation

    const $li = $(this).closest("li.main_menu_cu");

    // Reset all
    $("li.main_menu_cu").removeClass("active").find(".red-dot").remove();
    $("ul.sub_menu_cu").removeClass("show");

    // Activate clicked item
    $li.addClass("active");
    const $span = $li.find("a > span");
    if ($span.find(".red-dot").length === 0) {
      $("<div class='red-dot'></div>").prependTo($span);
    }

    // Show its submenu
    $li.find("ul.sub_menu_cu").addClass("show");
  });
});

document.addEventListener("DOMContentLoaded", function() {
  const slider = document.querySelector(".more-from-grid");
  let isDown = false;
  let startX;
  let scrollLeft;

  slider.addEventListener("mousedown", (e) => {
    isDown = true;
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });

  slider.addEventListener("mouseleave", () => {
    isDown = false;
  });

  slider.addEventListener("mouseup", () => {
    isDown = false;
  });

  slider.addEventListener("mousemove", (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 1.5; // scroll speed
    slider.scrollLeft = scrollLeft - walk;
  });
});